import React, { useEffect, useState } from 'react';
import { FaCircle, FaSync } from 'react-icons/fa';
import {
  changeVendorRetailerState,
  getVendorSettings,
} from '../../../server/server';
import { notif } from '../../utils/util';

function VendorSettings() {
  const [vendors, setVendors] = useState<any[]>([]);
  const [retailers, setRetailers] = useState<any[]>([]);

  const changeState = async (retailerId: any, vendorId: any) => {
    const resp = await changeVendorRetailerState(vendorId, retailerId);

    if (resp?.status === 201) {
      notif('Changed retailer success', 'success');
      loadSettings();
    }
  };

  const loadSettings = async () => {
    const resp = await getVendorSettings();
    if (resp?.status === 200) {
      setVendors(resp?.data?.vendors);
      setRetailers(resp?.data?.retailers);
    }
  };
  useEffect(() => {
    loadSettings();
  }, []);

  return (
    <div className="p-6 mb-24">
      <h1 className="text-gray-200 text-4xl font-semibold">Vendor Settings</h1>
      <h3 className="text-gray-400 my-2">
        Turn on/off vendors for different retailers. <br />
        Vendors that are turned off will not be shown in dropdown list for
        selected retailers.
      </h3>
      <div className="mt-12 flex flex-col gap-4 text-gray-200 ">
        {vendors?.map((v) => {
          return (
            <div className="flex ">
              <div className="w-[100px] mr-8 h-[40px] text-sm">{v?.name}</div>
              {retailers?.map((r: any) => {
                return (
                  <div
                    onClick={() => changeState(r?.id, v?.id)}
                    className={`h-[40px] px-4 rounded-md flex items-center justify-center cursor-pointer bor ${
                      v?.retailers?.map((r: any) => r?.id).includes(r?.id)
                        ? 'bg-[#5cb85c]'
                        : 'bg-[#d9534f]'
                    }`}
                  >
                    <FaSync className="mr-2" /> {r?.name}
                    {console.log(v?.retailers?.map((r: any) => r?.id))}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VendorSettings;
